import { Plugin } from 'rainbow-web-sdk/plugins/plugin';
import { BotService } from 'rainbow-web-sdk/services/bot/bot.service';
import { ConversationServiceRB } from 'rainbow-web-sdk/services/conversation/conversation.service';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { BubbleServiceRB } from 'rainbow-web-sdk/services/bubbles/bubble.service';

export class BubblesPlugin extends Plugin {
    public static initialize(): BubblesPlugin {
        Plugin.initialize();

        if (!window.rainbow.plugins[BubblesPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[BubblesPlugin] initialized");
            window.rainbow.plugins[BubblesPlugin.name] = new BubblesPlugin();
            BotService.getInstance();
            ConversationServiceRB.getInstance();
            BubbleServiceRB.getInstance();
        }

        return window.rainbow.plugins[BubblesPlugin.name];
    }

    private constructor() {
        super();
    }
}
